import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'

import { useRouter } from 'next/router'

import { LeftOutlined } from '@ant-design/icons'
import StyledInput from '@nexys/components/Input'
import LazyImgwrapper from '@nexys/components/LazyImgWrapper'
import Text from '@nexys/components/Typography/Text'
import useRole from '@nexys/hooks/useRole'
import {
  Button,
  Card,
  Col,
  Layout,
  notification,
  Row,
  Switch,
  Typography,
} from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { image } from 'constant'
import { Form, Formik } from 'formik'
import ApiCall from 'services/ApiCall'
import * as yup from 'yup'

import classes from 'views/Login/Login.module.scss'

interface LoginAttributes {
  email: string
  password: string
}

interface ForgotPasswordAttributes {
  email: string
}

interface ResetPasswordAttributes {
  body: {
    Password: string
    ConfirmPassword: string
  }
  token: any
  id: any
}

export default function Login() {
  const { xs, md, lg } = useBreakpoint()
  const postLogin = useMutation((data: LoginAttributes) => ApiCall.login(data))
  const postForgotPassword = useMutation((data: ForgotPasswordAttributes) =>
    ApiCall.ForgotPassword.sendEmail(data),
  )
  const postResetPassword = useMutation((data: ResetPasswordAttributes) =>
    ApiCall.ForgotPassword.resetPassword(data),
  )
  const router = useRouter()
  const role = useRole()
  const [forgotPassword, setForgotPassword] = useState(false)
  const [resetPassword, setResetPassword] = useState(false)

  useEffect(() => {
    if (router.isReady) {
      if (router.query?.id && router.query?.token) {
        setResetPassword(true)
      } else {
        switch (role) {
          case 'super admin':
            router.push('/admin')
            break
          case 'admin':
            router.push('/admin')
            break
          case 'user':
            router.push('/admin')
            break
          case 'member':
            router.push('/')
            break
          default:
            break
        }
      }
    }
  }, [router.isReady])

  const validateForm = () => {
    if (forgotPassword) {
      return yup.object().shape({
        email: yup.string().required('Email harus diisi!'),
      })
    } else if (resetPassword) {
      return yup.object().shape({
        password: yup.string().required(`Password harus diisi!`),
        rePassword: yup.string().required(`Password harus diisi!`),
      })
    } else {
      return yup.object().shape({
        email: yup.string().required('Email harus diisi!'),
        password: yup.string().required(`Password harus diisi!`),
      })
    }
  }

  return (
    <>
      <Layout
        style={{
          height: '100vh',
          background: '#FFFFFF',
          paddingRight: lg ? '80px' : '0px',
        }}
      >
        <Row
          align="middle"
          gutter={[50, 50]}
          style={{
            background: '#FFFFFF',
            display: md ? 'flex' : '',
            justifyContent: md ? 'center' : '',
            alignItems: md ? 'center' : '',
            height: '100vh',
          }}
        >
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={13}
            style={{ display: lg ? 'block' : xs ? 'none' : 'block' }}
          >
            <LazyImgwrapper>
              <img
                className={classes.loginIllustration}
                src={image.ilustrationLogin}
                alt="illustration"
              />
            </LazyImgwrapper>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={11}
            style={{
              backgroundColor: 'white',
              display: 'flex',
              flexDirection: 'column',
              marginTop: !lg ? '8px' : !md ? '8px' : '',
              alignSelf: 'flex-start',
              height: 'inherit',
              paddingTop: '45px',
              paddingLeft: xs && '40px',
              paddingRight: xs && '30px',
              justifyContent: 'center',
            }}
          >
            <div>
              <LazyImgwrapper
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: !lg ? '8px' : !md ? '8px' : '',
                }}
              >
                <img
                  className={classes.logoIllustration}
                  src={image.ilustrationLogo}
                  alt="illustration"
                />
              </LazyImgwrapper>
              <div className="mt-4">
                {!resetPassword && (
                  <div
                    className="flex items-center gap-4 py-3 cursor-pointer"
                    onClick={() => {
                      if (forgotPassword) {
                        setForgotPassword(false)
                      } else {
                        router.replace('/')
                      }
                    }}
                  >
                    <LeftOutlined />
                    <Text
                      style={{
                        fontFamily: 'Inter-Regular',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#5E5E5E',
                        lineHeight: '17px',
                      }}
                    >
                      {!forgotPassword ? `Kembali Ke Home` : `Kembali`}
                    </Text>
                  </div>
                )}
                <Text
                  style={{
                    paddingLeft: '16px',
                    fontFamily: 'Inter-Bold',
                    fontSize: '24px',
                    fontWeight: '700',
                    color: '#5E5E5E',
                    lineHeight: '150%',
                  }}
                >
                  {resetPassword
                    ? 'Reset Password'
                    : forgotPassword
                    ? `Masukkan Email Anda`
                    : `Masuk Ke Wilayah Penghuni`}
                </Text>
                <Card
                  bordered={false}
                  style={{
                    paddingTop: '0px',
                    width: '100%',
                    borderRadius: 15,
                    boxShadow: '0px 8px 40px rgba(134, 134, 134, 0.05)',
                  }}
                >
                  <Formik
                    initialValues={{ email: '', password: '', rePassword: '' }}
                    validationSchema={validateForm()}
                    onSubmit={async (values, { setSubmitting, setValues }) => {
                      setSubmitting(true)
                      try {
                        if (forgotPassword) {
                          const res = await postForgotPassword.mutateAsync(
                            values,
                          )

                          if (res.data.error) {
                            notification.error({
                              message: res.data.error?.data?.message,
                            })
                            return
                          }

                          notification.success({
                            message:
                              res.data?.message || 'Berhasil Mengirim Email',
                          })
                          setForgotPassword(false)
                        } else if (resetPassword) {
                          if (values.password !== values.rePassword) {
                            notification.error({
                              message: 'Pastikan password sama',
                            })
                            return
                          }
                          const send = {
                            body: {
                              Password: values.password,
                              ConfirmPassword: values.rePassword,
                            },
                            id: router.query?.id,
                            token: router.query?.token,
                          }
                          const res = await postResetPassword.mutateAsync(send)

                          if (res.data.error) {
                            notification.error({
                              message: res.data.error?.data?.message,
                            })
                            return
                          }

                          notification.success({
                            message:
                              res.data?.message ||
                              'Berhasil Mengganti Password Baru',
                          })
                          setResetPassword(false)
                          router.replace('/login')
                        } else {
                          const res = await postLogin.mutateAsync(values)

                          if (res.data.error) {
                            notification.error({
                              message: res.data.error?.data?.message,
                            })
                            return
                          }

                          notification.success({
                            message: res.data?.message,
                          })

                          const { token, type } = res.data
                          const tokenData = JSON.parse(
                            atob(token.split('.')[1]),
                          )

                          localStorage.setItem('access_token', token)
                          localStorage.setItem('type', type)
                          localStorage.setItem(
                            'full_name',
                            tokenData?.data?.fullName,
                          )
                          localStorage.setItem(
                            'role',
                            window.btoa(tokenData?.data?.role),
                          )

                          switch (tokenData?.data?.role) {
                            case 'super admin':
                              router.push('/admin')
                              break
                            case 'admin':
                              router.push('/admin')
                              break
                            case 'user':
                              router.push('/admin')
                              break
                            case 'member':
                              router.push('/')
                              break
                            default:
                              break
                          }
                        }
                      } catch (error) {
                        notification.error({
                          message: error.response.data?.message,
                        })
                        setSubmitting(false)
                      } finally {
                        setSubmitting(false)
                      }
                    }}
                  >
                    {({ handleChange, isSubmitting }) => (
                      <Form>
                        <Row
                          align="middle"
                          gutter={10}
                          justify="start"
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'start',
                          }}
                        >
                          {!resetPassword && (
                            <StyledInput
                              style={{ width: '100%' }}
                              topSpace={40}
                              label={'Email'}
                              id="email"
                              name="email"
                              type="text"
                              bordered
                              required
                              handleChange={handleChange}
                              placeholder={'cth:budibudiman01'}
                            />
                          )}
                          {!forgotPassword && (
                            <StyledInput
                              topSpace={30}
                              label={`Password`}
                              id="password"
                              name="password"
                              type="password"
                              bordered
                              required
                              handleChange={handleChange}
                            />
                          )}
                          {resetPassword && (
                            <StyledInput
                              topSpace={30}
                              label={`Ulangi Password`}
                              id="rePassword"
                              name="rePassword"
                              type="password"
                              bordered
                              required
                              handleChange={handleChange}
                            />
                          )}
                          {!forgotPassword && !resetPassword && (
                            <Row
                              justify="space-between"
                              style={{ width: '100%' }}
                            >
                              <Col style={{ marginTop: '16px' }}>
                                <Switch style={{ marginRight: '16px' }} />
                                <Typography.Text>Ingat Saya</Typography.Text>
                              </Col>
                              <Col
                                style={{ marginTop: '16px', cursor: 'pointer' }}
                                onClick={() => setForgotPassword(true)}
                              >
                                <Text>Lupa Password?</Text>
                              </Col>
                            </Row>
                          )}

                          <Button
                            type="primary"
                            color="black"
                            disabled={isSubmitting}
                            htmlType="submit"
                            size="large"
                            style={{
                              borderRadius: '4px !important',
                              width: '100%',
                              marginTop: '16px',
                            }}
                          >
                            {resetPassword
                              ? 'Reset Password'
                              : forgotPassword
                              ? `Kirim Email`
                              : `Login`}
                          </Button>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </Card>
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
    </>
  )
}
